import React from 'react';
import styles from './style/tab.module.css';

const Tab = ({
  active,
  disabled,
  handler,
  label,
}) => {
  const handleClick = () => {
    handler(label);
  };

  return (
    <button
      className={`${styles.tab} ${active ? styles.tab_active : ''}`}
      onClick={handleClick}
      type="button"
      disabled={disabled}
    >
      { label }
    </button>
  );
};

Tab.defaultProps = {
  active: false,
  disabled: false,
  handler: null,
};

export default Tab;
